module.exports = __webpack_public_path__ + "img/banner.32abe449.jpg";